import React from 'react';
import PropTypes from 'prop-types';

import {
  Menu,
  MenuContainer,
  Item,
} from './styles';
import { SIDE_TABS } from '../../../../company/pages/participants-video/video-features/constants';

const MenuFlaps = (props) => (
  <MenuContainer>
    <Menu pointing secondary stackable>
      {SIDE_TABS.map((option) => (
        <Item
          key={option}
          name={option}
          content={option}
          active={props.activeItem === option}
          onClick={props.onClickMenuItem}
        />
      ))}
    </Menu>
  </MenuContainer>
);

MenuFlaps.propTypes = {
  activeItem: PropTypes.string.isRequired,
  onClickMenuItem: PropTypes.func.isRequired,
};

export default MenuFlaps;
